import { Popper } from "../../../common/Popper";
// import * as jQuery from 'jquery';
import { ClickAwayListener } from "../../gameLib/ClickAwayListener";
import { convertCreditsFromServerToClient } from "../../datastructures/Credits";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { jackpotResults } from "../jackPotManager";
// import { GameData } from "../../gamestate/gameData";

export class JackpotDetailsFrame extends Popper {
  private parent: PIXI.Container;
  private parentContent: PIXI.Container = new PIXI.Container();
  private background: PIXI.Graphics;
  private cont_Total: PIXI.Container;
  private cont_LastWin: PIXI.Container;
  private cont_biggestWin: PIXI.Container;

  private bigTextStyle: PIXI.TextStyle;
  private midTextStyle: PIXI.TextStyle;
  private smallTextStyle: PIXI.TextStyle;

  private text_BiggestWin: PIXI.Text;
  private text_BiggestWinAmount: PIXI.Text;
  private text_BiggestWinDate: PIXI.Text;

  private noWinnerText: PIXI.Text;
  private text_LastWin: PIXI.Text;
  private text_LastWinAmount: PIXI.Text;
  private text_LastWinDate: PIXI.Text;
  private text_LastWinUser: PIXI.Text;
  private text_LastWinName: PIXI.Text;
  private text_TotalHead: PIXI.Text;
  private text_TotalBody: PIXI.Text;

  private isOpen: boolean;
  private openTween: PIXI.tween.Tween;
  private closeTween: PIXI.tween.Tween;
  private activeGameData: CommonData;
  // tween
  private extraTweens: Array<PIXI.tween.Tween>;
  private extraTweensSource: Array<PIXI.Text | PIXI.Container>;

  private detailsContainer: PIXI.Container;
  // private extraTween:
  private errorText: PIXI.Text = new PIXI.Text("");
  constructor(
    parent: PIXI.Container,
    frameWidth: number,
    activeGameData: CommonData
  ) {
    super(activeGameData);

    this.parent = new PIXI.Container();
    this.activeGameData = activeGameData;
    // console.log(this.activeGameData)
    //--------

    //-------
    this.parent = new PIXI.Container();

    this.cont_biggestWin = new PIXI.Container();
    this.cont_LastWin = new PIXI.Container();
    this.cont_Total = new PIXI.Container();
    this.parent.y = 50;

    this.background = new PIXI.Graphics();
    this.background.beginFill(0x122d44);
    // this.background.lineStyle(1, 0x00ff00);
    this.background.drawRoundedRect(0, 0, frameWidth, 320, 10);
    // this.background.drawRoundedRect(0, 0, this.parent.width ,400,0);
    this.background.endFill();
    this.background.alpha = 0.8;
    this.background.height = 320;
    this.background.on("pointertap", this.onClick.bind(this));
    parent.addChild(this.parent);
    this.parent.addChild(this.background);
    //-----------------------
    this.errorText = new PIXI.Text("", {
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 35,
      fontWeight: "bold",
      fill: ["#ff0000"], // gradient
      stroke: "#000000",
      strokeThickness: 5,
    });
    this.errorText.anchor.set(0.5);
    this.parent.addChild(this.errorText);
    this.errorText.x = frameWidth / 2;
    this.errorText.y = 320 / 2;
    //----------------
    this.parent.addChild(this.parentContent);
    this.detailsContainer = new PIXI.Container();
    this.parentContent.addChild(this.detailsContainer);

    this.addClickAwayListener(
      new ClickAwayListener(
        activeGameData.stage,
        this.background,
        this.close.bind(this)
      )
    );
    this.detailsContainer.addChild(this.cont_biggestWin);
    this.detailsContainer.addChild(this.cont_LastWin);
    this.detailsContainer.addChild(this.cont_Total);

    this.bigTextStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fill: ["#f0c99b", "#fcb262"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });
    this.midTextStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 22,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });
    this.smallTextStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 20,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.noWinnerText = new PIXI.Text(
      activeGameData.gameTextGeneral.noWinner,
      this.bigTextStyle
    );
    this.noWinnerText.anchor.set(0.5);
    this.noWinnerText.x = this.parent.width / 2;
    this.noWinnerText.y = this.parent.height / 2;
    this.parent.addChild(this.noWinnerText);
    //--biggest win
    // console.log(this.cont_biggestWin.height)
    this.cont_biggestWin.y = 10;
    this.text_BiggestWin = new PIXI.Text(
      activeGameData.gameTextGeneral.jpWins1,
      this.midTextStyle
    );
    this.cont_biggestWin.addChild(this.text_BiggestWin);
    this.text_BiggestWinDate = new PIXI.Text("00/00/0000", this.smallTextStyle);
    // this.text_BiggestWin.x=this.parent.width-this.text_BiggestWin.width-10;
    this.text_BiggestWinDate.x = 10;
    this.cont_biggestWin.addChild(this.text_BiggestWinDate);
    this.text_BiggestWinAmount = new PIXI.Text(
      "0 " + activeGameData.currency,
      this.bigTextStyle
    );
    this.cont_biggestWin.addChild(this.text_BiggestWinAmount);
    this.text_BiggestWinAmount.y = this.text_BiggestWin.height;
    // this.text_BiggestWinAmount.x= this.parent.width-this.text_BiggestWinAmount.width-10;

    //last win
    this.cont_LastWin.y = 100;
    this.text_LastWin = new PIXI.Text(
      activeGameData.gameTextGeneral.jpWins3,
      this.midTextStyle
    );
    this.cont_LastWin.addChild(this.text_LastWin);
    this.text_LastWinDate = new PIXI.Text("00/00/0000", this.smallTextStyle);
    // this.text_LastWinDate.x=10;
    this.text_LastWin.x = this.parent.width - this.text_LastWin.width - 10;
    this.cont_LastWin.addChild(this.text_LastWinDate);

    this.text_LastWinName = new PIXI.Text("/", this.bigTextStyle);
    this.cont_LastWin.addChild(this.text_LastWinName);
    this.text_LastWinName.y = 30;
    // this.text_LastWinName.x= this.parent.width-this.text_LastWinName.width-10;

    this.text_LastWinUser = new PIXI.Text(
      activeGameData.gameTextGeneral.username,
      this.smallTextStyle
    );
    this.text_LastWinUser.y = this.text_LastWinName.y;
    this.text_LastWinUser.x = 10;
    // this.cont_LastWin.addChild(this.text_LastWinUser); //hide username

    this.text_LastWinAmount = new PIXI.Text(
      "0 " + activeGameData.currency,
      this.bigTextStyle
    );
    this.cont_LastWin.addChild(this.text_LastWinAmount);
    this.text_LastWinAmount.y = this.text_LastWinName.y * 2;
    // this.text_LastWinAmount.x= this.parent.width-this.text_LastWinAmount.width-10;
    //total wins
    this.cont_Total.y = 220;
    this.text_TotalHead = new PIXI.Text(
      activeGameData.gameTextGeneral.jpWins2,
      this.midTextStyle
    );
    this.cont_Total.addChild(this.text_TotalHead);
    // this.text_TotalHead.x= this.parent.width-this.text_TotalHead.width-10;

    this.text_TotalBody = new PIXI.Text("0", this.bigTextStyle);
    this.cont_Total.addChild(this.text_TotalBody);
    this.text_TotalBody.y = this.text_TotalHead.height;
    // this.text_TotalBody.x= this.parent.width-this.text_TotalBody.width-10;

    //----openClose tween
    this.isOpen = true;
    this.openTween = PIXI.tweenManager.createTween(this.parent);
    this.openTween.time = 500;
    this.openTween.from({ alpha: 0, y: -100 }).to({ alpha: 1, y: 50 });
    this.openTween.easing = PIXI.tween.Easing.outBack();

    this.closeTween = PIXI.tweenManager.createTween(this.parent);
    this.closeTween.time = 500;
    this.closeTween.from({ alpha: 1, y: 50 }).to({ alpha: 0, y: 0 });
    this.closeTween.easing = PIXI.tween.Easing.outExpo();
    this.close();

    //--declare extras animations tween on open close
    this.extraTweens = [];
    this.extraTweensSource = [
      this.text_BiggestWin,
      this.text_BiggestWinAmount,
      this.text_LastWin,
      this.text_LastWinName,
      this.text_LastWinAmount,
      this.text_TotalHead,
      this.text_TotalBody,
    ];

    // this.extraTweensSource=[this.cont_biggestWin,this.cont_LastWin,this.cont_Total]//this.text_BiggestWin,this.text_BiggestWinAmount,this.text_LastWin,this.text_LastWinName,this.text_LastWinAmount,this.text_TotalHead,this.text_TotalBody]
    for (var i = 0; i < this.extraTweensSource.length; i++) {
      this.extraTweens[i] = PIXI.tweenManager.createTween(
        this.extraTweensSource[i]
      );
      this.extraTweens[i].time = 500 + 50 * i;
      if (this.activeGameData.isMobile) {
        this.extraTweens[i].time = 1;
      }
      this.extraTweens[i]
        .from({ alpha: 0, y: this.extraTweensSource[i].y - 140 })
        .to({ alpha: 1, y: this.extraTweensSource[i].y });
      this.extraTweens[i].easing = PIXI.tween.Easing.outBack();
    }

    if (this.activeGameData.isMobile) {
      this.openTween.time = 1;
      this.closeTween.time = 1;
    } else {
      this.openTween.time = 500;
      this.closeTween.time = 500;
    }

    this.align();
    this.setVisible(false); //default display empty
  }

  public onClick() {
    // console.log("counts")

    if (this.isOpen) {
      //close
      this.close();
    } else {
      //open
      // this.closeOpened(this.activeGameData)
      // this.makeClickable(true);
      this.closeTween.stop();
      this.closeTween.reset();
      this.openTween.reset();
      this.openTween.start();
      this.isOpen = true;
      this.extraAnimation();
      // this.activeGameData.jackpotBarClose.buttonMode=true;
      // this.activeGameData.jackpotBarClose.interactive=true;
      this.open();
    }
  }

  // makeClickable(_bool:boolean)
  // {
  //     // this.background.interactive=bool;
  //     // this.background.buttonMode=bool;
  // }
  public removeFromCanvas() {
    // this.makeClickable(false);
    if (this.isOpen) {
      this.openTween.stop();
      this.openTween.reset();
      this.closeTween.reset();
      this.closeTween.start();
      // this.activeGameData.jackpotBarClose.buttonMode = false;
      // this.activeGameData.jackpotBarClose.interactive = false;
      this.isOpen = false;
    }
    // console.log('sss');
  }
  private extraAnimation = (): void => {
    for (var i = 0; i < this.extraTweensSource.length; i++) {
      this.extraTweens[i].reset();
      this.extraTweens[i].start();
    }
  };
  public setVisible = (bool: boolean): void => {
    this.detailsContainer.alpha = bool ? 1 : 0;
    this.noWinnerText.alpha = !bool ? 1 : 0;
  };
  public getVisible = (): number => {
    return this.detailsContainer.alpha;
  };
  public updateDetailsValues = (data: jackpotResults): void => {
    if (data.bigWinDateTime != undefined) {
      let localTime = new Date(data.bigWinDateTime);
      let addZeroHours = "0";
      let addZeroMinutes = "0";
      if (localTime.getHours() > 9) {
        addZeroHours = "";
      }
      if (localTime.getMinutes() > 9) {
        addZeroMinutes = "";
      }

      // let displayTime=localTime.getFullYear()+'/'+(localTime.getMonth()+1)+'/'+localTime.getDate()+' '+addZeroHours+ localTime.getHours()+':'+addZeroMinutes+localTime.getMinutes();

      // let displayDateFormat=localTime.getDate()+'/'+localTime.getMonth()+'/'+localTime.getFullYear();//older
      let displayDateFormat = localTime.toLocaleDateString("en-GB");
      let displayTime =
        displayDateFormat +
        " " +
        addZeroHours +
        localTime.getHours() +
        ":" +
        addZeroMinutes +
        localTime.getMinutes();
      this.text_BiggestWinDate.text = displayTime;
      // console.log(localTime.toLocaleDateString())
    }

    if (data.bigWinValue != undefined) {
      let displayVal = convertCreditsFromServerToClient(
        data.bigWinValue.amount
      );

      this.text_BiggestWinAmount.text =
        displayVal + " " + data.bigWinValue.currency;
    }

    if (data.lastWinDateTime != undefined) {
      this.setVisible(true);
      let localTime = new Date(data.lastWinDateTime);
      let addZeroHours = "0";
      let addZeroMinutes = "0";
      if (localTime.getHours() > 9) {
        addZeroHours = "";
      }
      if (localTime.getMinutes() > 9) {
        addZeroMinutes = "";
      }
      let displayTime =
        localTime.toLocaleDateString("en-GB") +
        " " +
        addZeroHours +
        localTime.getHours() +
        ":" +
        addZeroMinutes +
        localTime.getMinutes();

      this.text_LastWinDate.text = displayTime;
    }

    if (data.lastWinValue != undefined) {
      let displayVal = convertCreditsFromServerToClient(
        data.lastWinValue.amount
      );

      this.text_LastWinAmount.text =
        displayVal + " " + data.bigWinValue.currency;
    }

    if (data.lastWinWinnerDisplayName != undefined) {
      this.text_LastWinName.text = data.lastWinWinnerDisplayName as string;
    }

    if (data.timesWon != undefined) {
      this.text_TotalBody.text = data.timesWon + "";
    }
  };

  private align = (): void => {
    this.text_BiggestWin.anchor.set(1, 0);
    this.text_BiggestWinAmount.anchor.set(1, 0);
    this.text_LastWin.anchor.set(1, 0);
    this.text_LastWinName.anchor.set(1, 0);
    this.text_TotalHead.anchor.set(1, 0);
    this.text_TotalBody.anchor.set(1, 0);
    this.text_LastWinAmount.anchor.set(1, 0);

    this.text_BiggestWin.x = this.background.width - 10;
    this.text_BiggestWinAmount.x = this.text_BiggestWin.x;
    this.text_LastWinDate.x = 10;
    this.text_LastWin.x = this.text_BiggestWin.x;

    this.text_LastWinName.x = this.text_BiggestWin.x;

    this.text_LastWinUser.x = 10;

    this.text_TotalHead.x = this.text_BiggestWin.x;

    this.text_TotalBody.x = this.text_BiggestWin.x;

    this.text_LastWinAmount.x = this.text_BiggestWin.x;
  };

  public alignTo = (aligntype: string, parentWidth: number): void => {
    //center,left,right
    if (aligntype == "left") {
      this.parent.x = 0; //default
    }
    if (aligntype == "right") {
      this.parent.x = parentWidth - this.parent.width; //default
    }
    if (aligntype == "center") {
      this.parent.x = parentWidth / 2 - this.parent.width / 2; //default
    }
  };

  public setAvailable = (bool: boolean): void => {
    bool;
    this.parentContent.visible = bool; //-set content visible if avaialble
    this.errorText.text = bool
      ? ""
      : this.activeGameData.gameTextGeneral.Unavailable;
    // this.parent.scale.set(bool ? 1 : 0);
  };
}
